import * as actionTypes from '../actions/actionTypes'

const initialState = {
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null
}

const updateProfileStart = (state, action) => {
  return { ...state, loading: true }
}

const updateProfileSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateProfileFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PROFILE_START:
      return updateProfileStart(state, action)
    case actionTypes.UPDATE_PROFILE_SUCCESS:
      return updateProfileSuccess(state, action)
    case actionTypes.UPDATE_PROFILE_FAILED:
      return updateProfileFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
